import React from "react";

function Footer() {
  return (
    <footer style={styles.footer}>
      <p>© {new Date().getFullYear()} Abo Ther Al-Ghafari Mosque | All Rights Reserved</p>
    </footer>
  );
}

const styles = {
  footer: {
    backgroundColor: "#067446ff",
    color: "white",
    textAlign: "center",
    padding: "10px",
    marginTop: "auto",
  },
};

export default Footer;
